var swiper = new Swiper(".relatedProducts", {
  slidesPerView: "auto",
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 8,
      loop: true,
      watchSlidesVisibility: true,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  },
});
